<template>
    <div class="vue-location-wrapper">
        <div class="vue-location-finder">
            <div class="container h-100">
                <div class="row h-100">
                    <div class="vue-location-search-wrapper col-12 col-lg-5 col-xl-4">
                        <div class="vue-location-search">
                            <aut-geo-input
                              @input="handleGeoInput"
                              @reset="handleReset"
                              :disabled="loading"
                              @geo="handleGeo"
                              @loading="handleLoading"
                            ></aut-geo-input>

                            <div class="vue-location-search-result" :class="{ 'has-result': location !== null }">
                              <transition name="fade">
                                <aut-location-sidebar
                                  v-if="! location"
                                  :locations="locationsForSidebar"
                                  :event-bus="eventBus"
                                  :loading="loading"
                                ></aut-location-sidebar>
                                <aut-location-detail
                                    v-else
                                    :location="location"
                                    :event-bus="eventBus"
                                ></aut-location-detail>
                              </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <aut-location-finder
                v-if="! isMobile"
                :locations="locations"
                :event-bus="eventBus"
            ></aut-location-finder>
        </div>
    </div>
</template>

<script>
import GeoInput from "./GeoInput";
import SideBar from "./SideBar";
import Finder from "./Finder";
import LocationCardDetails from "./LocationCardDetails";
import translations from "../../mixins/translations";
import Vue from "vue";

export default {
    name: "locationWrapper",

    mixins: [translations],

    components: {
        'aut-geo-input': GeoInput,
        'aut-location-sidebar': SideBar,
        'aut-location-finder': Finder,
        'aut-location-detail': LocationCardDetails,
    },

    data() {
        return {
            loading: false,
            geoLocation: {},
            inputQuery: false,
            locations: [],
            location: null,
            eventBus: new Vue(),
            isMobile: window.matchMedia('(max-width: 991px)').matches,
        }
    },

    computed: {
        locationsForSidebar() {
            return lodash.take(this.locations, 10);
        },

        hasGeoLocation() {
            return !lodash.isEmpty(this.geoLocation);
        }
    },

    created() {
        this.fetchLocations();
    },

    mounted() {
        window.addEventListener('resize', lodash.debounce(() => {
            this.isMobile = window.matchMedia('(max-width: 991px)').matches;
        }, 250));

        this.eventBus.$on('location-clicked', (payload) => {
            this.fetchLocation(payload);
        });

        this.eventBus.$on('location-card-back-button-clicked', (payload) => {
            this.location = null;
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.isMobile = window.matchMedia('(max-width: 991px)').matches;
        });
    },

    methods: {
        handleGeo({payload}) {
            this.geoCenterMap(payload)
        },

        handleGeoInput(payload) {
            this.location = null;
            this.inputQuery = true;
            this.geoCenterMap(payload)
        },

        geoCenterMap(payload) {
            this.geoLocation = payload;
            this.fetchLocations();
            this.eventBus.$emit('set-map-center', this.geoLocation);
        },

        handleReset() {
            this.geoLocation = {};
            this.eventBus.$emit('reset-map');
            this.fetchLocations();
        },

        fetchLocations() {
            this.loading = true;

            let apiUrl = `/api/locations?limit=999`;

            if (this.hasGeoLocation) {
                apiUrl += `&lat=${this.geoLocation.lat}&lng=${this.geoLocation.lng}`;
            }

            axios.get(apiUrl)
                .then(response => {
                    this.locations = response.data;
                })
                .finally(() => this.loading = false );
        },

        fetchLocation(id) {
            this.loading = true;
            window.scrollTo(0, 0);

            let apiUrl = `/api/location-details?locationId=${id}`;

            axios.get(apiUrl)
              .then(response => {
                this.location = response.data;
              })
              .finally(() => this.loading = false );
        },

        handleLoading(payload) {
            this.loading = payload;
        }
    },
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-to { opacity: 0 }

.fade-leave,
.fade-enter-to { opacity: 1 }

.fade-enter-active { transition: opacity .2s .2s }
.fade-leave-active { transition: opacity .2s 0s }
</style>
